import { useTranslation } from "react-i18next"
import { Button } from "@gogoro/go-design"
import { useAuth } from "customerAttachments/auth/AuthProvider"
import Card from "customerAttachments/components/Card"
import ErrorIcon from "customerAttachments/icons/Icon-error.svg"
import { useNavigation } from "modules/navigation"

import styles from "./styles.module.scss"

const ErrorPage = () => {
  const { t } = useTranslation("sales")
  const { user } = useAuth() || {}
  const { navigateTo } = useNavigation()

  return (
    <div className={styles.errorPage_container}>
      <Card
        title={t("label:description")}
        content={
          <div className={styles.errorPage_description}>
            {t("customer_attachments.welcome_description", { name: user?.Name || "" })}
          </div>
        }
      />
      <Card
        title={t("customer_attachments.search_result")}
        content={
          <div className={styles.errorPage_content}>
            <img alt="error_icon" src={ErrorIcon} className={styles.errorPage_errorIcon} />
            <h3>{t("customer_attachments.order_not_found")}</h3>
            <p>{t("customer_attachments.incorrect_url_please_redirect")}</p>
            <Button onClick={() => navigateTo("/")}>{t("customer_attachments.back_to_homepage")}</Button>
          </div>
        }
      />
    </div>
  )
}

export default ErrorPage
